import styled from 'styled-components';
import { device } from '../../../../util/commonMediaStylesUtil';

export const TableData1A = styled.span`
  font-size: 14px;
  color: #155cb4;
  font-family: 'EYInterstate';
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
`;
export const TableData1ACell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
  color: red;
`;
export const TableData1B = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-family: 'EYInterstate Bold';
  font-weight: bold;
`;
export const TableData1BCell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
`;

export const TableData1C = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  font-family: 'EYInterstate';
`;

export const TableData1CCell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
`;
export const TableData2ANumStyle = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  font-family: 'EYInterstate Light';
`;

export const TableData2ACell = styled.span`
  display: flex;
  align-items: center;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  padding: 12px 10px;
  margin: 10px;
`;

export const TableData2BNumStyle = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  font-weight: bold;
  font-family: 'EYInterstate Light Bold';
`;

export const TableData2BCell = styled.span`
  display: flex;
  align-items: center;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6; /* Fixed missing '1px solid' */
  background-color: #e1e1e6;
  padding: 12px 10px;
`;
export const TableData3Text = styled.span`
  color: #2e2e38;
  font-family: 'EYInterstate Light';
  font-size: 14px;
`;

export const TableData3ACell = styled.span`
  display: flex;
  align-items: center;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  padding: 12px 10px;
  margin: 10px;
`;
export const TableData3DotStyle = styled.span`
  width: 10px;
  height: 10px;

  background-color: red;
  border-radius: 50%;
  margin-right: 10px;
`;

export const TableData4Cell = styled.span`
  height: 50px;
  width: 200px;
  border-color: #e1e1e6;
  border-width: 1px;
  border-style: solid;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 10px;
  padding-right: 10px;
`;
export const TableData5Text = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #155cb4;
  font-family: 'EYInterstate Light Bold';
  margin-left: 10px;
`;
export const TableData5Cell = styled.span`
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e6;
  background-color: #e1e1e6;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
`;
export const TableData5Icon = styled.span`
  margin-left: auto;
  margin-right: 10px;
  color: #155cb4;
`;
export const TableData6Text = styled.span`
  color: #2e2e38;
  font-family: 'EYInterstate Light';
  align-items: left;
`;
export const TableData6Cell = styled.span`
  display: flex;
  height: 50px;
  width: 200px;
  border: 1px solid #e1e1e6; /* Assuming 'E1E1E6' is the color, also added 'solid' */
  padding: 12px 5px;
`;
export const TableData7Cell = styled.span`
  height: 50px;
  width: 200px;
  border-color: #e1e1e6;
  border-width: 1px;
  border-style: solid;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  vertical-align: middle;
  text-align: center;
  margin: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 10px;
  padding-right: 10px;
`;
export const TableToggle = styled.span`
  font-size: 12px;
  line-height: 20px;
`;

// Empty Forcast Styles
export const EmptyForcastText = styled.span`
  color: #1a1a24;
  font-family: 'EYInterstate';
  font-size: 28px;
  font-weight: 400;
  text-align: center;
  line-height: 30px;
`;

export const EmptyForcastContainer = styled.div`
  padding-top: 250px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
`;

export const CellWarningError = styled.span`
  color: #b9251c;
  font-family: EYInterstate;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0px;
  line-height: 20px;
`;

export const TableData1CBold = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #2e2e38;
  font-weight: bold;
`;

export const PLPastStatusCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const PLTableContainer = styled.div`
  flex: 3;
  height: calc(100vh - 228px);
  max-height: calc(100vh - 228px);

  @media (max-width: 768px) {
    height: calc(90vh - 75px);
  }
`;

export const PLPastTableContainer = styled.div`
  flex: 3;
  height: calc(100vh - 228px);
  max-height: calc(100vh - 228px);

  @media (max-width: 768px) {
    height: calc(90vh - 75px);
  }
`;

// Mobile View
export const OppsContainer = styled.div`
  // border: 1px solid pink;
`;

export const OppsListContainer = styled.div`
  padding: 0px;
  padding-bottom: 80px;
  list-style-type: none !important;
`;

export const OppsItemContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 6fr 1.5fr;
  border-bottom: 1px solid #e1e1e6;
  padding: 10px 10px 10px 10px;

  ${device.phone_md`
    grid-template-columns: 0.8fr 6fr 0.8fr;
 `}
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ItemTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemLinkText = styled.div`
  color: #155cb4;
  font-size: 16px;
  line-height: 28px;
`;

export const ItemDetailsText = styled.div`
  color: #2e2e38;
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  display: flex; //
`;

export const ItemAwdDateText = styled.div`
  color: red;
  font-size: 14px;
  line-height: 20px;
`;

export const ItemTovValueContainer = styled.div`
  color: #000000
  font-size: 14px;
  text-align: right;
`;

export const DateContainer = styled.span``;

export const DateWarningContainer = styled.span`
  color: #b9251c;
  font-family: EYInterstate;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0px;
  line-height: 20px;
  // padding-left: 25px;
`;

export const AwdDateMainContainer = styled.span`
  display: flex;
`;
export const WarningIconContainer = styled.span`
  display: flex;
`;
